


































import Vue from "vue";

// vue component
import StocksContentTable from "@/views/App/Components/StocksContentTable.vue";

// model
import { formatCurrency } from "@/utility/Formatter";
import { InstallationContent } from "@/model/data/content/InstallationContent";
import { MachineContent } from "@/model/data/content/MachineContent";
import { Machine } from "@/model/data/Machine";

export default Vue.extend({
    components: {
        StocksContentTable,
    },
    props: {
        installation: { type: Object as () => InstallationContent },
        machineSerialNumber: String,
    },
    computed: {
        machineContent(): MachineContent {
            let res: MachineContent = new MachineContent();
            if (this.installation.contentMachines.filter((cm: MachineContent) => cm.machineSerialNumber == this.machineSerialNumber).length > 0)
                res = this.installation.contentMachines.filter((cm: MachineContent) => cm.machineSerialNumber == this.machineSerialNumber)[0];
            return res;
        },

        getModelFromSerialNumber(): string {
            let modelString: string = "";
            this.installation.machines.forEach((machine: Machine) => {
                if (machine.serialNumber == this.machineSerialNumber) {
                    modelString = machine.model;
                }
            });
            return modelString;
        },

        getTotalsByCurrencies() {
            return this.machineContent.content.getTotalsByCurrencies();
        },
    },
    methods: {
        formatCurrency,
    },
});
